'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@extern/ui/card';
const AuthCard = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Card className="mx-auto w-full p-0 sm:max-w-[320px] md:max-w-[380px]">{children}</Card>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthCardHeader = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardHeader className="mb-8 w-full gap-4 p-0">{children}</CardHeader>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthCarTitle = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardTitle className="text-center font-dm font-normal text-3xl text-black leading-8">{children}</CardTitle>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthCardDescription = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardDescription className="text-center font-inter font-normal text-base text-gray-dark leading-6">{children}</CardDescription>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthCardContent = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardContent className="flex w-full flex-col gap-6 p-0">{children}</CardContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AuthCardFooter = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardFooter className="flex w-full flex-col gap-6 px-0 py-6">{children}</CardFooter>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
AuthCard.Header = AuthCardHeader;
AuthCard.Title = AuthCarTitle;
AuthCard.Description = AuthCardDescription;
AuthCard.Content = AuthCardContent;
AuthCard.Footer = AuthCardFooter;
export { AuthCard };